module.exports = __webpack_public_path__ + "img/oman_flag.a0310615.png";